<template>
    <div class="sub_title template4">
        <span class="desc">{{
            $t('md-search-result.theAveragePriceIn', { desc })
        }}</span>
        <a
            class="link"
            :href="url"
            target="_blank"
            rel="noopener noreferrer"
        >{{ $t('md-search-result.learnMore') }}</a>
    </div>
</template>

<script>
import core from '../../sub-title';
export default {
    mixins: [core]
};
</script>

<style lang="scss">
@import '../../../../theme/media.scss';
.sub_title.template4 {
    padding-top: 15px;
    padding-bottom: 20px;
    font-size: 14px;
    color: #8b93a7;
    .desc {
        vertical-align: middle;
    }
    .link {
        color: #4c84ff;
        cursor: pointer;
        vertical-align: middle;
    }
    @include media-800 {
        padding: 8px 15px 0 15px;
    }
}
</style>
